import React, { useEffect, useState } from 'react'
import InfoPainel from './InfoPainel'
import MenuPainel from './MenuPainel'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import PainelContent from './components/PainelContent'
import MeuPerfil from './components/MeuPerfil'
import { useMenuStorage } from '../../storage/menu'
import Carteirinha from './components/Carteirinha'
import Matriculados from './components/Matriculados'
import CursosView from './components/CursosView'
import './styles.css'
import { getAllCursosMatriculados, getAllCursosTotais } from '../../utils'
import { getImagemByUserId } from '../../Api'
import { useGlobalCarteira } from '../../storage/globalCarteira'
import Cookies from "js-cookie";
import { salvarImagemLocal } from '../../storage/indexedDbService'
import LoadingUI from '../../components/LoadingUI'
import FullScreenLoading from '../../components/FullScreenLoading'

export default function Painel() {

    const [loading, setLoading] = useState(false);
    const setDataCarteira = useGlobalCarteira(state => state.setDataCarteira);

    const user = localStorage.getItem("user");
    const stateStorage = JSON.parse(user)

    useEffect(() => {
        getAllCursosMatriculados();
        getAllCursosTotais();

        const user = localStorage.getItem("user");
        const state = JSON.parse(user);

        const imagem = Cookies.get("imagem");
        if (imagem === 'false') {
            setLoading(true);

            getImagemByUserId({ id: state.estudante_id })
                .then(async (res) => {
                    await salvarImagemLocal('imagemUser', res.data.imagem); // Aguarda salvar a imagem
                    setDataCarteira({ ...stateStorage, imagem: res.data.imagem })
                    Cookies.remove("imagem");
                })
                .catch((err) => {
                    console.error("Erro ao buscar ou salvar imagem:", err);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, []);

    useEffect(() => {
        console.log('asda222q1435125435162')
    }, [loading])


    const { selectedMenu } = useMenuStorage(state => state.dados)

    /* if (loading) return <LoadingUI message="Carregando dados do Estudante..." />; */

    return (
        <div>
            <FullScreenLoading open={loading} />
            <Header />
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>

                <div style={{ width: '100%', maxWidth: '1340px', padding: '0 20px' }}>

                    <InfoPainel />
                    <hr color='#ddd'></hr>

                    <div className='menuDiv'>

                        <MenuPainel />

                        {
                            selectedMenu === 'Painel' && <PainelContent />
                        }
                        {
                            selectedMenu === 'Meu perfil' && <MeuPerfil />
                        }
                        {
                            selectedMenu === 'Carteirinha' && <></>
                        }
                        {
                            selectedMenu === 'Cursos Matriculados' && <Matriculados />
                        }
                        {
                            selectedMenu === 'Cursos' && <CursosView />
                        }
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}
